import { ErrorBoundary, Shadow, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { TableHeadContainer, TableHeadItem } from '../../../../../../components/TableHead';
import { flatListProps, tableHeadCustomerData } from '../../../../utils';
import { CustomerItemDataResponseProps, orderByProps } from '../../../../utils/types';
import { Separator } from '../../../Separator';
import { Item } from '../Item';
import { Skeleton } from '../Skeleton';

interface TableProps {
  orderBy: orderByProps;
  isLoading: boolean;
  isLoadingMore: boolean;
  error?: Error;
  response: CustomerItemDataResponseProps;
  refresher: () => void;
  onEndReached: () => void;
  skeletonItemCount: number;
  onOrderBy: (value?: string) => void;
}

export const Table: React.FC<TableProps> = ({
  isLoading,
  orderBy,
  refresher,
  response,
  isLoadingMore,
  error,
  onEndReached,
  skeletonItemCount,
  onOrderBy,
}) => {
  return (
    <VStack space={Spacing['inline.nano']} {...(error && { pb: Spacing['inline.xxxs'] })}>
      {!error && response && response?.data?.length > 0 && (
        <TableHeadContainer>
          {tableHeadCustomerData.map((item) => (
            <TableHeadItem
              key={item.title}
              {...item}
              {...(item.title === 'Nome' && { flex: 2 })}
              orderBy={orderBy}
              onPress={() => item.value && onOrderBy(item.value)}
            />
          ))}
        </TableHeadContainer>
      )}
      <Shadow level={2} borderTopRadius={BoxRadius.sm}>
        {isLoading && <Skeleton itemsCount={skeletonItemCount} />}
        {!isLoading && !error && response && response?.data?.length > 0 && (
          <FlatList
            {...flatListProps}
            data={response?.data}
            keyExtractor={(item) => item.accountNumber.toString()}
            ItemSeparatorComponent={Separator}
            onEndReached={onEndReached}
            ListFooterComponent={
              <Box py={Spacing['inline.quarck']}>{isLoadingMore && <Skeleton />}</Box>
            }
            renderItem={({ item }) => <Item item={item} />}
          />
        )}
        {!isLoading && error && (
          <Box py={{ sm: Spacing['inline.md'] }}>
            <ErrorBoundary onRefresh={refresher} {...error} />
          </Box>
        )}
        {!isLoading && !error && response && response?.data?.length === 0 && (
          <Box py={{ sm: Spacing['inline.md'] }}>
            <ErrorBoundary
              onRefresh={refresher}
              errorIconOrIllustration="NotEmptyIllustration"
              errorTitle="Nenhuma informação encontrada."
              errorMessage="No momento não há dados disponíveis. Por favor, tente novamente mais tarde."
            />
          </Box>
        )}
      </Shadow>
    </VStack>
  );
};
